import { authApi } from '../../utils/api';

export const adminPolicelerPage = () => {
    const user = authApi.getCurrentUser();

    if (!user || user.rol !== 'admin') {
        return `
            <section class="page-content">
                <div class="container">
                    <div class="alert alert-danger">
                        <p>Bu sayfaya erişim yetkiniz yok.</p>
                        <a href="/" class="btn-primary">Ana Sayfaya Dön</a>
                    </div>
                </div>
            </section>
        `;
    }

    return `
        <section class="page-content admin-page">
            <div class="container">
                <div class="page-header">
                    <h1 class="page-title">Poliçe Yönetimi</h1>
                    <div class="header-actions">
                        <a href="/admin" class="btn-outline">← Admin Paneli</a>
                        <button class="btn-primary" id="addPoliceBtn">+ Yeni Poliçe</button>
                    </div>
                </div>

                <!-- Poliçe Ekleme/Düzenleme Modal -->
                <div id="policeModal" class="modal" style="display: none;">
                    <div class="modal-content modal-large">
                        <div class="modal-header">
                            <h2 id="policeModalTitle">Yeni Poliçe Ekle</h2>
                            <button class="modal-close" id="closePoliceModal">&times;</button>
                        </div>
                        <form id="policeForm" class="modal-form">
                            <input type="hidden" id="policeId">

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="policeUserId">Kullanıcı *</label>
                                    <select id="policeUserId" class="form-control" required>
                                        <option value="">Kullanıcı Seçin</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="policeRuhsatId">Ruhsat</label>
                                    <select id="policeRuhsatId" class="form-control">
                                        <option value="">Ruhsat Seçin (Opsiyonel)</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="sigortaTipi">Sigorta Tipi *</label>
                                    <select id="sigortaTipi" class="form-control" required>
                                        <option value="">Seçin</option>
                                        <option value="trafik">Trafik</option>
                                        <option value="kasko">Kasko</option>
                                        <option value="dask">DASK</option>
                                        <option value="imm">İMM</option>
                                        <option value="e-kasko">E-Kasko</option>
                                        <option value="seyahat">Seyahat</option>
                                        <option value="tamamlayici">Tamamlayıcı Sağlık</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="policeNo">Poliçe No</label>
                                    <input type="text" id="policeNo" class="form-control">
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="baslangicTarihi">Başlangıç Tarihi</label>
                                    <input type="date" id="baslangicTarihi" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="bitisTarihi">Bitiş Tarihi</label>
                                    <input type="date" id="bitisTarihi" class="form-control">
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="primTutari">Prim Tutarı (TL)</label>
                                    <input type="number" id="primTutari" class="form-control" step="0.01" min="0">
                                </div>
                                <div class="form-group">
                                    <label for="policeDurum">Durum</label>
                                    <select id="policeDurum" class="form-control">
                                        <option value="aktif">Aktif</option>
                                        <option value="beklemede">Beklemede</option>
                                        <option value="iptal">İptal</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="muayeneTarihi">Muayene Tarihi</label>
                                <input type="date" id="muayeneTarihi" class="form-control">
                            </div>

                            <div class="form-group">
                                <label for="notlar">Notlar</label>
                                <textarea id="notlar" class="form-control" rows="3"></textarea>
                            </div>

                            <div class="form-group">
                                <label for="policeBelge">Belge Ekle (PDF/Görsel)</label>
                                <input type="file" id="policeBelge" class="form-control" accept=".pdf,image/*" multiple>
                                <small class="form-hint">Poliçe PDF, evrak veya teminat belgesi ekleyebilirsiniz. Birden fazla dosya seçebilirsiniz.</small>
                            </div>

                            <div id="policeFormError" class="error-message" style="display: none;"></div>
                            <div class="modal-actions">
                                <button type="button" class="btn-outline" id="cancelPoliceBtn">İptal</button>
                                <button type="submit" class="btn-primary">Kaydet</button>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Filtreler -->
                <div class="filters">
                    <select id="filterTip" class="form-control">
                        <option value="">Tüm Tipler</option>
                        <option value="trafik">Trafik</option>
                        <option value="kasko">Kasko</option>
                        <option value="dask">DASK</option>
                        <option value="imm">İMM</option>
                        <option value="e-kasko">E-Kasko</option>
                        <option value="seyahat">Seyahat</option>
                        <option value="tamamlayici">Tamamlayıcı</option>
                    </select>
                    <select id="filterDurum" class="form-control">
                        <option value="">Tüm Durumlar</option>
                        <option value="aktif">Aktif</option>
                        <option value="beklemede">Beklemede</option>
                        <option value="iptal">İptal</option>
                    </select>
                </div>

                <div id="policelerList" class="data-table-container">
                    <div class="loading">Yükleniyor...</div>
                </div>
            </div>
        </section>
    `;
};
